import { observable, reaction, runInAction } from "mobx"

import { withGlobalLoader } from "@/lib/context.ts"
import { Model } from "@/lib/Model.ts"

import type { ProfileIdentifier, SshKeyData } from "@/lib/client/generated/TypeDefinitions.ts"
import type { GlobalContext } from "@/lib/context.ts"
import type { Queries } from "@/lib/queries.ts"


export class SshKeysTabModel extends Model {
  readonly keys = observable.box<SshKeyData[] | null>(null)
  readonly error = observable.box<Error | null>(null)

  readonly publicKey = observable.box("")
  readonly comment = observable.box("")

  constructor(
    private readonly context: GlobalContext,
    private readonly queries: Queries,
    readonly profile: ProfileIdentifier.Username,
    private readonly onUpdate?: () => void
  ) {
    super("SshKeysTabModel")

    this.lifetime.add(reaction(
      () => ({
        keys: this.keys.get(),
      }),
      ({ keys }) => {
        this.isLoading.set(keys == null)
      }
    ), "SshKeysTabModel:isLoading")

    void this.loadKeys()
  }

  readonly loadKeys = async () => {
    const data = await this.queries.listSshKeys(this.profile)

    runInAction(() => {
      this.keys.set(data)
    })
  }

  readonly addKey = async (profile: ProfileIdentifier.Username, key: string, comment: string) => {
    await withGlobalLoader(this.context, this.queries.apiClient.addSshKey(profile, key, comment))
    await this.loadKeys()
    this.onUpdate?.()
  }

  readonly deleteKey = async (profile: ProfileIdentifier.Username, fingerprint: string) => {
    await withGlobalLoader(this.context, this.queries.apiClient.deleteSshKey(profile, fingerprint))
    await this.loadKeys()
    this.onUpdate?.()
  }
}